/**
 * AboutPage (route: "/about")
 * Introduces the masjid project. Reuses the About, Friday Prayer and Support
 * sections from the home page beneath a page-title banner.
 */
import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import About from '../../components/about';
import FridayPrayer from '../../components/FridayPrayer';
import Support from '../../components/Support';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
// TODO: Replace placeholder illustration with a real Cole Harbour Masjid photo once available
import abimg from '../../images/placeholder-illustration.svg';

const AboutPage = () => {
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={'About Us'} pagesub={'About'} />
      <About aboutImg={abimg} />
      {/* TODO: Re-enable <Pilars /> here when the Five Pillars section is needed again. */}
      <FridayPrayer />
      <Support />
      <Footer footerClass={'wpo-ne-footer-2'} />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
